import React from "react";
import { Provider } from "react-redux";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import BrandLeaderBoardModule from "./BrandLeaderBoardModule";
import { createReduxStore } from "../../utils/createReduxStore";
import reducer from "./redux/BrandLeaderBoardReducer";
import rootSaga from "./redux/BrandLeaderBoardSagas";

const BrandLeaderBoard = (props) => {
  let {
    params: {
      organization_id,
      short_url,
      calendarStartDate,
      calendarEndDate,
      displayViewDropdown,
      qa
    },
    notifications
  } = props;
  let params = {
    organization_id,
    short_url,
    calendarEndDate,
    calendarStartDate,
    displayViewDropdown,
    isUserQa: qa
  };

  return (
    <Provider store={createReduxStore(reducer, "BrandLeaderBoard", rootSaga)}>
      <ErrorBoundary moduleName="BrandLeaderBoard" {...notifications}>
        <BrandLeaderBoardModule params={params} />
      </ErrorBoundary>
    </Provider>
  );
};

export default BrandLeaderBoard;
